var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-content"},[_c('MenuList',{attrs:{"nav-links":_vm.navLinks,"right":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }